export default function Title({ size = 'big', text }) {
  const baseClasses = 'font-bold text-center';
  const variants = {
    big: 'sm:text-4xl text-xl',
    small: 'sm:text-2xl text-xl',
  };

  const tokens = (text || '').match(/([^\s!]+|!)/g) || [];
  const words = tokens.filter((t) => t !== '!').slice(0, 5);
  const hasExclamation = tokens.includes('!');
  const colors = ['text-blue', 'text-red', 'text-yellow', 'text-blue', 'text-green'];

  return (
    <h1 className={`${baseClasses} ${variants[size]}`}>
      {words.map((w, i) => {
        const addSpace = i < words.length - 1 || !hasExclamation;
        return (
          <span key={i}>
            <span className={colors[i] || ''}>{w}</span>
            {addSpace ? ' ' : null}
          </span>
        );
      })}
      {hasExclamation && <span className="text-red">!</span>}
    </h1>
  );
}
